module.exports = __webpack_public_path__ + "static/media/school-icon.54337129.svg";